<template>
  <ul
    class="flex justify-between gap-5 text-white"
    :class="{ 'flex-col h-52 ml-4': showItemsVertical }"
  >
    <li>
      <NuxtLink
        class="p-4 flex items-center justify-center rounded-full bg-[#1877F2]"
        :to="linkFacebook"
        target="_blank"
        @click="trackShare('facebook')"
      >
        <TIcon
          :icon="['fab', 'facebook']"
          size="lg"
        />
      </NuxtLink>
    </li>
    <li>
      <NuxtLink
        class="p-4 flex items-center justify-center rounded-full bg-black"
        :to="linkTwitter"
        target="_blank"
        @click="trackShare('twitter')"
      >
        <TIcon
          :icon="['fab', 'x-twitter']"
          size="lg"
        />
      </NuxtLink>
    </li>
    <li>
      <NuxtLink
        class="p-4 flex items-center justify-center rounded-full bg-primary-900"
        :to="linkEmail"
        target="_blank"
        @click="trackShare('email')"
      >
        <TIcon
          :icon="['fas', 'envelope']"
          size="lg"
        />
      </NuxtLink>
    </li>
    <li>
      <NuxtLink
        class="p-4 flex items-center justify-center rounded-full bg-[#1877F2]"
        :to="linkMessenger"
        target="_blank"
        @click="trackShare('messenger')"
      >
        <TIcon
          :icon="['fab', 'facebook-messenger']"
          size="lg"
        />
      </NuxtLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
const props = defineProps<{
  url: string
  page: string
  showItemsVertical?: boolean
}>()

const runtimeConfig = useRuntimeConfig()

const linkFacebook = computed(() => `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl('fb')}`)
const linkTwitter = computed(() => `https://twitter.com/intent/tweet?url=${encodedUrl('tw')}`)
const linkEmail = computed(() => `mailto:?body=${encodedUrl('email')}`)
const linkMessenger = computed(
  () =>
    `http://www.facebook.com/dialog/send?app_id=${runtimeConfig.public.facebook.appId}&link=${encodedUrl('fbms')}&redirect_uri=https://www.rvezy.com/`,
)

function encodedUrl(source: string) {
  const separator = props.url.includes('?') ? '&' : '?'
  return encodeURI(props.url + `${separator}utm_source=sb${source}`)
}

function trackShare(type: string) {
  trackShareButtonClicked({
    url: props.url,
    type,
    page: props.page,
  })
}
</script>
